import React from "react";
import { ModalContainer } from "../../provider";
import CreateClientProvider from "../../../createClient/provider";
import Form from "./form";
import { useCreatClientHook } from "../../../createClient/hooks";

const CreateClient = () => {
  const { isLoading, submitForm } = useCreatClientHook();
  return (
    <div className="flex flex-col max-h-[80vh] items-center pb-6 pt-3 px-10 gap-3 bg-white rounded-md w-[500px] shadow-md ">
      <span className="flex text-primary font-semibold text-[20px]">
        Ajouter un nouveau client
      </span>
      <Form />
      <button
        onClick={!isLoading ? submitForm : void {}}
        className="flex px-12 py-2 bg-primary hover:bg-hover active:bg-active rounded-md"
        style={{
          background: isLoading ? "rgba(249, 154, 14, 0.75)" : undefined,
        }}
      >
        <span className="flex text-white">
          {isLoading ? "chargement..." : "Enregister le client"}
        </span>
      </button>
    </div>
  );
};

const CreateClientFromModel = ({ size = { h: 0, w: 0 } }) => {
  return (
    <ModalContainer {...{ size }}>
      <CreateClientProvider>
        <CreateClient />
      </CreateClientProvider>
    </ModalContainer>
  );
};

export default CreateClientFromModel;
